export default __webpack_public_path__ + "static/media/Руководство пользователя SKARB-SOIL 1.1.2025.33a2e6c4.pdf";